import React, {useEffect, useState} from 'react';
import Frame from "../components/layout/Frame";
import {Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import {getFHList} from "../api/apiClient";
import Moment from "moment";
import DateEquipmentSearchBox from "../components/searchBoxs/DateEquipmentSearchBox";
import {useLocation} from 'react-router-dom';
import TableFR from "../components/tables/TableFR";

const FaultResult = () => {

  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  // 검색 조건
  const [searchParam, setSearchParam] = useState({
    searchFcltyNo: '',   // 시설명
    startDate: new Date(),
    searchFromSi: '00',
    searchLcKnd: '',    // 발생유형
    searchMssage: '',   // 발생위치
    searchTerm: "H", // 검색조건 (기준)
    searchSttus: '', // 장애상태
    searchSeriusLevel: "", // 장애등급
    searchToSi: '23',
    endDate: new Date(),
  });
  // 검색 버튼 클릭했는지
  const [isSearch, setIsSearch] = useState(true);

  const updateList = () => {
    getFHList(currentPage, listPageSize,
        searchParam.searchFcltyNo,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        searchParam.searchFromSi,
        searchParam.searchLcKnd,
        searchParam.searchMssage,
        searchParam.searchSeriusLevel,
        searchParam.searchSttus,
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.searchToSi,
    ).then((res) => {
          if (res.data.data !== undefined) {
            setTableList(res.data.data.list);
            setTotal(res.data.data.total);
          }
        }
    );
  };

  const getExportData = () => {
    // excel pdf를 위함.
    return getFHList(currentPage, listPageSize,
        searchParam.searchFcltyNo,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        searchParam.searchLcKnd,
        searchParam.searchMssage,
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.searchFromSi,
        searchParam.searchToSi
    );
  };

  useEffect(() => {
    setIsSearch(false);
  }, []);

  useEffect(() => {
    updateList();
  }, [isSearch, currentPage, listPageSize]);

  /*const location = useLocation();
  const [propFaultLevel, setPropFaultLevel] = useState(location.state?.propText);

  useEffect(() => {
    console.log(propFaultLevel);
    if (propFaultLevel === "Critical") {
      // setPropFaultLevel("3");
      console.log("Critical!!!")
      setSearchParam({...searchParam, searchSeriusLevel: "3", searchSttus: "1"});
    } else if (propFaultLevel === "Major") {
      // setPropFaultLevel("2");
      console.log("Major!!!")
      setSearchParam({...searchParam, searchSeriusLevel: "2", searchSttus: "1"});
    } else if (propFaultLevel === "Minor") {
      // setPropFaultLevel("1");
      console.log("Minor!!!")
      setSearchParam({...searchParam, searchSeriusLevel: "1", searchSttus: "1"});
    } else {
      console.log("All!!!");
      // setPropFaultLevel("");
      setSearchParam({...searchParam, searchSeriusLevel: "", searchSttus: ""});  // 전체
    }
  }, [propFaultLevel]);*/

  const location = useLocation();
  const [propNavData, setNavData] = useState({
    rcpt_no: location.state?.rcpt_no,
    isPopupOpen: location.state?.isPopupOpen,
  });

  useEffect(() => {
    console.log(propNavData);
  }, [propNavData]);

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid>
          <Row className={"p-3"}>
            <Col md={12} className={"search-container py-2"}>
              <DateEquipmentSearchBox
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  setCurrentPage={setCurrentPage}
                  updateList={updateList}
              />
            </Col>
            <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
              <TableFR
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  listPageSize={listPageSize}
                  setListPageSize={setListPageSize}
                  total={total}
                  tableList={tableList}
                  updateList={updateList}
                  getFullData={getExportData}
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  setIsSearch={setIsSearch}
                  setTableList={setTableList}
                  setTotal={setTotal}
                  propNavData={propNavData}
              />
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default FaultResult;
